import * as React from "react";
import { PlatformContext } from "../../../../components/context/platform";
import { GroupByType } from "../../../../components/GroupByType";

export function typeToDisplay(type: string) {
    switch (type) {
        case 'genre_name':
            return 'Genre'
        case 'sub_genre_name':
            return 'Sub Genre'
    }
    return 'Category'
}

export function CategoryGroupBy(props: { onTypeChange: (type: string) => void, preventSubGenre?: boolean }) {

    const platform = React.useContext(PlatformContext)
    const [type, setType] = React.useState<string>(platform == 'create' ? 'genre_name' : 'category_name')

    const toolbarItems = GroupByType([
        { val: 'category_name', display: 'Categories' },
        { val: 'genre_name', display: 'Genre' }], type, (selected) => {
            setType(selected!)
        }, false)

    const createToolbarItems = GroupByType([
        { val: 'genre_name', display: 'Genre' },
        { val: 'sub_genre_name', display: 'Sub Genre' }], type, (selected) => {
            setType(selected!)
        }, false)

    React.useEffect(() => {
        props.onTypeChange(type)
    }, [type])

    React.useEffect(() => {
        if (type == 'category_name') {
            setType('genre_name')
        }
    }, [platform])

    if (platform == 'create') {
        if (props.preventSubGenre) {
            return createToolbarItems.slice(0, 0)
        }
        return createToolbarItems
    }
    return toolbarItems
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Category/charts/GroupByHelper.tsx